import React from "react";
import "./multimediaContent.scss";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";
import LikeButton from "../../molecules/like-button/like-button";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import LibraryRecommendation from "../library-recommendation/libraryRecommendation";

const MultimediaContent = (props : ReferenciaContenido) => {

    const {referenciaMultimedia: refMultimedia} = props;

    return(
        <>

            <div className="o-multimedia-content-like-btn">
                <LikeButton contentId={props.contentful_id} contentType={CONTENT_TYPE_ARTICULO}/>
            </div>
            
            <div className="o-multimedia-content">
                <div className="container">
                    <div className="o-multimedia-content__container">
                        {refMultimedia[0].categoriaMultimedia == "Artículo" && (
                            <div className="o-multimedia-content__container__description">
                                {contentfulRenderOptions(refMultimedia[0].descripcion.json)}
                            </div>
                        )}
                        {refMultimedia[0].categoriaMultimedia == "Podcast" &&(
                            <>
                                <div className="o-multimedia-media-player">
                                    <div className="o-multimedia-media-player__content">
                                        <img src={refMultimedia[0].imagenPrincipal.file.url}/>
                                        <div className="o-multimedia-media-player__content__text">
                                            <h2>{refMultimedia[0].tituloMultimedia}</h2>
                                            <p>{`Autor: ${refMultimedia[0].autor}`}</p>
                                        </div>
                                    </div>
                                    {refMultimedia[0].audio?.file.url ? (
                                        <AudioPlayer 
                                            src={refMultimedia[0].audio?.file.url}
                                            layout="horizontal-reverse"
                                            className="media-player"
                                            showJumpControls={false}
                                            showSkipControls={false}
                                        />
                                    ) : (
                                        <AudioPlayer 
                                            src={refMultimedia[0].audioUrl}
                                            layout="horizontal-reverse"
                                            className="media-player"
                                            showJumpControls={false}
                                            showSkipControls={false}
                                        />
                                    )}
                                    
                                </div>
                            </>
                        )}
                        {refMultimedia[0].categoriaMultimedia == "Historias que conectan" && (
                            <div className="o-multimedia-content__container__description">
                                {contentfulRenderOptions(refMultimedia[0].descripcion.json)}
                            </div>
                        )}
                        {refMultimedia[0].categoriaMultimedia == "Webinar" && (
                            <div className="o-multimedia-content__container__description">
                                {refMultimedia[0].descripcion && contentfulRenderOptions(refMultimedia[0].descripcion.json)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <LibraryRecommendation {...props}/>
        </>
    );
}

export default MultimediaContent;
